<h2 mat-dialog-title id="dialog-title">DECLARATION BY THE USER OF PI OR SPI</h2>

<mat-dialog-content class="mat-typography">
  <div class="container-fluid signup_form">
    <div class="row inner_signup_form">
      <div class="col-md-12">
        <div>
          <div
            [innerHtml]="tncText"
            id="tnc-text"
            tabindex="1"
            style="outline: none !important"
            class="privacy_content"
          ></div>
          <div class="row">
            <div class="col-md-12" style="padding: 0">
              <div class="field-bg">
                <button type="button" id="readproceedBtn" class="custom-color" (click)="presonalConsentSubmit()">
                  ACCEPT AND PROCEED
                </button>

                <br />
                <label style="position: relative; float: left; text-transform: capitalize" id="copyright-label"
                  >Copyright © 2020 Infosys Limited</label
                >
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
